<main class="d-grid gap-4">
  <div class="d-flex justify-content-between align-items-center">
    <div class="page-header">
      <div
        class="d-flex align-items-center gap-3"
        style="cursor: pointer"
        (click)="goBack()"
      >
        <i class="fas fa-arrow-left back-icon"></i>
        <div class="page-title">Ethnicity</div>
      </div>
    </div>
    <app-button
      [label]="'Add ethnicity'"
      [minWidth]="'10rem'"
      (clicked)="openAddEthnicity()"
    >
    </app-button>
  </div>

  <div class="table-container">
    <app-table
      [columns]="columns"
      [data]="ethnicityData"
      [actionTemplate]="actionButtonsTemplate"
      [loading]="loading"
      tableName="Ethnicity"
    >
    </app-table>
  </div>
</main>

<ng-template #actionButtons let-row>
  <div class="action-buttons-container">
    <img
      class="action-button"
      (click)="onEdit(row)"
      src="assets/images/Buttons/edit-button.svg"
      alt="Edit"
      title="Edit"
    />
    <img
      class="action-button"
      (click)="onDelete(row)"
      src="assets/images/Buttons/delete-button.svg"
      alt="Delete"
      title="Delete"
    />
  </div>
</ng-template>